import { RootState } from "../../store";
import { AccountAttemptStatusDetailsAwsStarted } from "../../../services/cloudchipr.api";

export const cliCommandSelector = (state: RootState): string | undefined =>
  (
    state.accountSetup.accountAttempt?.status_details
      ?.started as AccountAttemptStatusDetailsAwsStarted
  )?.cli_command?.replaceAll(/\\,/g, "\\,");
